<template>
  <div
    class="flex flex-col bg-primary-purple-50 gap-2 lg:gap-3 1.5xl:gap-4 p-5 rounded-19 w-full md:md:[width:calc(50%-10px)] lg:lg:[width:calc(50%-12px)]"
  >
    <h3
      v-i18n="landingPage"
      class="text-lg leading-6 lg:text-xl lg:leading-7 1.5xl:text-3xl 1.5xl:leading-[42px] text-center"
    >
      {{ scrollableContent.mainHeading }}
    </h3>

    <div class="w-full flex flex-col">
      <Carousel :details="carouselImages" />
    </div>
  </div>
</template>

<script>
import Carousel from '@src/views/home-page/Carousel.vue'

export default {
  components: {
    Carousel,
  },
  props: {
    scrollableContent: {
      type: Object,
      default: () => {},
    },
    carouselImages: {
      type: Array,
      required: true,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      landingPage: 'landingPage',
    }
  },
}
</script>
